import React, { Component } from "react";
import getData from "./data";
import { getRows } from "./data";
import Filters from "./Filters.js";
import Table from "./Table";
import "../../styles/features/DocumentsFilters/DocumentsFilters.css";
import PageHead from "../../components/PageHead";
import { Tag } from "antd";
import { Link } from "react-router-dom";
import Spinner from "../../containers/Spinner";

class FilterComponent extends Component {
  state = { rows: [], filters: {}, nrFilters: 0 };
  componentWillMount = async () => {
    this.fetchRows();
    let data = await getData();
    this.setState({ data, finished: true });
  };
  fetchRows = async () => {
    let rows = await getRows(this.state.filters);
    this.setState({ rows });
  };
  kerko = () => {
    this.fetchRows();
  };
  changeFilter = (type, formObj, id) => {
    console.log(type, formObj, id);
    let nrFilters = this.state.nrFilters;
    let filters = this.state.filters;
    if (type === "select") {
      if (formObj.name === "Propozues") {
        filters[formObj.name] = id;
      } else {
        filters[formObj.name] = { name: formObj.queryName, id };
      }

      this.setState({ filters, nrFilters });
    } else {
      filters[formObj.name] = { name: formObj.queryName, id };
    }
  };
  render() {
    if (!this.state.finished) {
      return <Spinner />;
    }
    var width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    var columns = [];
    if (this.state.data) {
      columns = this.state.data[0].table;

      if (width < 900 && width > 600) {
        columns = [
          {
            title: "Titulli",
            dataIndex: "Titulli",
            key: "Titulli"
          },
          {
            title: "Date Regjistrimi",
            dataIndex: "DateRegjistrimi",
            key: "DateRegjistrimi"
          },

          {
            title: "Lloji",
            dataIndex: "Lloji",
            key: "Procedura"
          },
          {
            title: "",
            dataIndex: "ID",
            key: "ID",
            render: tags => (
              <span>
                <Tag color={"blue"}>
                  {" "}
                  <Link to={"/akte/" + tags}>Shiko me shume</Link>
                </Tag>
              </span>
            )
          }
        ];
      }
      if (width < 600) {
        columns = [
          {
            title: "Titulli",
            dataIndex: "Titulli",
            key: "Titulli"
          },
          {
            title: "Lloji",
            dataIndex: "Lloji",
            key: "Procedura"
          },
          {
            title: "",
            dataIndex: "ID",
            key: "ID",
            render: tags => {
              return (
                <span>
                  <Tag color={"blue"}>
                    {" "}
                    <Link to={"/akte/" + tags}>Shiko me shume</Link>
                  </Tag>
                </span>
              );
            }
          }
        ];
      } else {
        columns = [
          {
            title: "Titulli",
            dataIndex: "Titulli",
            key: "Titulli"
          },
          {
            title: "Date Regjistrimi",
            dataIndex: "DateRegjistrimi",
            key: "DateRegjistrimi"
          },

          {
            title: "Statusi",
            dataIndex: "Statusi",
            key: "Statusi"
          },
          {
            title: "Procedura",
            dataIndex: "Procedura",
            key: "Procedura"
          },
          {
            title: "Lloji",
            dataIndex: "Lloji",
            key: "Procedura"
          },
          {
            title: "",
            dataIndex: "ID",
            key: "ID",
            render: tags => {
              console.log(tags);
              return (
                <span>
                  <Tag color={"blue"}>
                    {" "}
                    <Link to={"/akte/" + tags}>Shiko me shume</Link>
                  </Tag>
                </span>
              );
            }
          }
        ];
      }
    }

    console.log(width);
    return (
      <>
        <PageHead text="Kerko akte" />
        <div style={{ height: "auto", margin: "0px 7vw" }}>
          {this.state.data ? (
            <>
              <Filters
                kerko={this.kerko}
                data={this.state.data[0]}
                changeFilter={this.changeFilter}
                pastro={() => {
                  this.setState(
                    {
                      filters: {},
                      nrFilters: 0
                    },
                    () => {
                      this.fetchRows();
                    }
                  );
                }}
              />
              <hr class="gradient_line" />
              <Table columns={columns} data={this.state.rows} />
            </>
          ) : null}
        </div>
      </>
    );
  }
}

export default FilterComponent;
